module.exports = __webpack_public_path__ + "img/setting1.2ffbc91b.png";